<template> </template>

<script>
import axios from "axios";
import Base from "@/views/modules/base/Index";
import { mapState, mapActions } from "vuex";

export default {
  name: "RawFileDownload",
  extends: Base,
  computed: {
    ...mapState("auth", ["user"])
  },
  methods: {
    ...mapActions("exchange", ["saveRawFileCode"]),
    ...mapActions("common", ["showModal"])
  },
  beforeMount() {
    const code =
      (this.$route.query && this.$route.query.code) ||
      this.$store.state.exchange.rawFileCode;

    this.saveRawFileCode(code);

    if (code && this.user) {
      axios({
        url: `/incoming/exchange/raw/${encodeURIComponent(code)}`,
        method: "GET",
        responseType: "blob"
      })
        .then(res => {
          const regex = /filename="(.*?)"/;
          const str = res.headers["content-disposition"];
          let fileName = regex.exec(str)[1];
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          if (navigator.msSaveBlob) {
            this.saveRawFileCode(null);
            this.$router.push({ name: "dashboard" });
            return navigator.msSaveBlob(new Blob([res.data]), fileName);
          } else {
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
          }
          this.saveRawFileCode(null);
          this.$router.push({ name: "dashboard" });
        })
        .catch(err => {
          this.saveRawFileCode(null);
          this.$router.push({ name: "login" });
          if (err.response && err.response.status !== 401) {
            this.showModal({
              title: this.$t("file-not-available")
            });
          }
        });
    } else {
      this.$router.push({ name: "login" });
    }
  }
};
</script>
